module.exports = __webpack_public_path__ + "img/normativa.7ab8c4b7.svg";